// Wishlist SVG Icons
const wishlistEmptyIcon = `<?xml version="1.0" encoding="UTF-8"?><svg id=vuoto viewBox="0 0 130.84 123.07"xmlns=http://www.w3.org/2000/svg><defs><style>.cls-1{fill:#034a73;stroke-width:0}</style></defs><path class=cls-1 d=m97.82,7c1.1,0,2.23.09,3.37.25,7.08,1.05,12.75,4.7,16.84,10.84,3.6,5.39,5.72,12.49,5.81,19.47.18,13.05-5.64,28.8-15.97,43.21-11.01,15.35-26.07,27.86-42.44,35.25-16.37-7.39-31.43-19.89-42.44-35.25-10.33-14.41-16.16-30.16-15.97-43.21.1-6.98,2.22-14.08,5.81-19.47,4.1-6.14,9.76-9.79,16.84-10.84,1.13-.17,2.26-.25,3.37-.25,9.06,0,17.82,5.83,26.79,17.82l5.61,7.5,5.61-7.5c8.96-11.99,17.72-17.82,26.79-17.82M97.82,0C84.93,0,74.39,8.63,65.42,20.63,56.45,8.63,45.91,0,33.03,0c-1.43,0-2.9.11-4.39.33C8.89,3.25.22,22.03,0,37.46c-.41,29.61,25.56,68.4,62.83,85.07.81.36,1.7.54,2.59.54s1.77-.18,2.59-.54c37.27-16.67,63.24-55.45,62.83-85.07-.22-15.43-8.88-34.21-28.63-37.14C100.71.11,99.25,0,97.82,0h0Z /></svg>`;

const wishlistFillIcon = `<?xml version="1.0" encoding="utf-8"?><svg id=vuoto style="enable-background:new 0 0 130.8 123.1"version=1.1 viewBox="0 0 130.8 123.1"x=0px xml:space=preserve xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink y=0px><style>.st0{fill:#034a73}</style><path class=st0 d="M97.8,7c1.1,0,2.2,0.1,3.4,0.2c7.1,1.1,12.8,4.7,16.8,10.8c3.6,5.4,5.7,12.5,5.8,19.5c0.2,13-5.6,28.8-16,43.2	c-11,15.3-26.1,27.9-42.4,35.2C49.1,108.6,34,96.1,23,80.8C12.7,66.4,6.8,50.6,7,37.6c0.1-7,2.2-14.1,5.8-19.5	c4.1-6.1,9.8-9.8,16.8-10.8C30.8,7.1,31.9,7,33,7c9.1,0,17.8,5.8,26.8,17.8l5.6,7.5l5.6-7.5C80,12.8,88.8,7,97.8,7"/><path class=st0 d="M130.8,37.5c0.4,29.6-25.6,68.4-62.8,85.1c-0.8,0.4-1.7,0.5-2.6,0.5c-0.9,0-1.8-0.2-2.6-0.5	C25.6,105.9-0.4,67.1,0,37.5C0.2,22,8.9,3.3,28.6,0.3C30.1,0.1,31.6,0,33,0c12.9,0,23.4,8.6,32.4,20.6C74.4,8.6,84.9,0,97.8,0 c1.4,0,2.9,0.1,4.4,0.3C122,3.3,130.6,22,130.8,37.5z"/></svg>`;

const wishlistPopupCloseIcon = 'X';

const wishlistDeleteIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M1871 5109 c-128 -25 -257 -125 -311 -241 -37 -79 -50 -146 -50 -259 l0 -89 -389 0 c-222 0 -411 -4 -442 -10 -187 -36 -330 -184 -361 -376 -30 -181 66 -371 231 -458 l69 -36 6 -58 c4 -31 65 -763 136 -1627 72 -863 134 -1587 139 -1608 36 -155 177 -295 335 -332 91 -22 2561 -22 2652 0 158 37 299 177 335 332 5 21 67 745 139 1608 71 864 132 1596 136 1627 l6 58 69 36 c165 87 261 277 231 458 -31 192 -174 340 -361 376 -31 6 -220 10 -442 10 l-389 0 0 89 c0 48 -5 112 -10 142 -34 180 -179 325 -359 359 -66 12 -1306 12 -1370 -1z m1359 -309 c60 -31 80 -78 80 -190 l0 -90 -750 0 -750 0 0 90 c0 110 20 159 78 189 36 19 60 20 670 21 615 0 634 -1 672 -20z m1200 -600 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -39 -20 -55 -20 -1870 -20 -1815 0 -1831 0 -1870 20 -45 23 -80 80 -80 130 0 48 35 107 78 129 36 20 65 20 1870 21 1818 0 1833 0 1872 -20z m-236 -622 c-2 -24 -63 -747 -134 -1606 -140 -1694 -129 -1598 -193 -1646 l-28 -21 -1279 0 -1279 0 -28 21 c-64 48 -53 -48 -193 1646 -71 859 -132 1582 -134 1606 l-6 42 1640 0 1640 0 -6 -42z"></path><path d="M1587 3299 c-25 -13 -45 -34 -58 -62 l-21 -43 76 -1234 c85 -1381 76 -1299 155 -1340 51 -25 91 -25 142 0 27 14 46 34 60 63 l21 43 -76 1234 c-85 1381 -76 1299 -155 1340 -50 25 -95 25 -144 -1z"></path><path d="M2488 3299 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -57 -20 -1280 0 -1224 0 -1241 20 -1280 23 -45 80 -80 130 -80 50 0 107 35 130 80 20 39 20 56 20 1280 0 1224 0 1241 -20 1280 -37 73 -127 99 -202 59z"></path><path d="M3387 3299 c-77 -41 -68 37 -153 -1339 l-76 -1234 21 -43 c14 -29 33 -49 60 -63 51 -25 91 -25 142 0 79 41 70 -41 155 1340 l76 1234 -21 43 c-37 75 -127 103 -204 62z"></path></g></svg>`;
const wishlistLikeEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 478.2 478.2" style="" xml:space="preserve" class=""><g><path d="M457.575 325.1c9.8-12.5 14.5-25.9 13.9-39.7-.6-15.2-7.4-27.1-13-34.4 6.5-16.2 9-41.7-12.7-61.5-15.9-14.5-42.9-21-80.3-19.2-26.3 1.2-48.3 6.1-49.2 6.3h-.1c-5 .9-10.3 2-15.7 3.2-.4-6.4.7-22.3 12.5-58.1 14-42.6 13.2-75.2-2.6-97-16.6-22.9-43.1-24.7-50.9-24.7-7.5 0-14.4 3.1-19.3 8.8-11.1 12.9-9.8 36.7-8.4 47.7-13.2 35.4-50.2 122.2-81.5 146.3-.6.4-1.1.9-1.6 1.4-9.2 9.7-15.4 20.2-19.6 29.4-5.9-3.2-12.6-5-19.8-5h-61c-23 0-41.6 18.7-41.6 41.6v162.5c0 23 18.7 41.6 41.6 41.6h61c8.9 0 17.2-2.8 24-7.6l23.5 2.8c3.6.5 67.6 8.6 133.3 7.3 11.9.9 23.1 1.4 33.5 1.4 17.9 0 33.5-1.4 46.5-4.2 30.6-6.5 51.5-19.5 62.1-38.6 8.1-14.6 8.1-29.1 6.8-38.3 19.9-18 23.4-37.9 22.7-51.9-.4-8.1-2.2-15-4.1-20.1zm-409.3 122.2c-8.1 0-14.6-6.6-14.6-14.6V270.1c0-8.1 6.6-14.6 14.6-14.6h61c8.1 0 14.6 6.6 14.6 14.6v162.5c0 8.1-6.6 14.6-14.6 14.6h-61v.1zm383.7-133.9c-4.2 4.4-5 11.1-1.8 16.3 0 .1 4.1 7.1 4.6 16.7.7 13.1-5.6 24.7-18.8 34.6-4.7 3.6-6.6 9.8-4.6 15.4 0 .1 4.3 13.3-2.7 25.8-6.7 12-21.6 20.6-44.2 25.4-18.1 3.9-42.7 4.6-72.9 2.2h-1.4c-64.3 1.4-129.3-7-130-7.1h-.1l-10.1-1.2c.6-2.8.9-5.8.9-8.8V270.1c0-4.3-.7-8.5-1.9-12.4 1.8-6.7 6.8-21.6 18.6-34.3 44.9-35.6 88.8-155.7 90.7-160.9.8-2.1 1-4.4.6-6.7-1.7-11.2-1.1-24.9 1.3-29 5.3.1 19.6 1.6 28.2 13.5 10.2 14.1 9.8 39.3-1.2 72.7-16.8 50.9-18.2 77.7-4.9 89.5 6.6 5.9 15.4 6.2 21.8 3.9 6.1-1.4 11.9-2.6 17.4-3.5.4-.1.9-.2 1.3-.3 30.7-6.7 85.7-10.8 104.8 6.6 16.2 14.8 4.7 34.4 3.4 36.5-3.7 5.6-2.6 12.9 2.4 17.4.1.1 10.6 10 11.1 23.3.4 8.9-3.8 18-12.5 27z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>'
const wishlistLikeFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.999 511.999" style="" xml:space="preserve" class=""><g><path d="M15.34 224.948c-8.365 0-15.146 6.782-15.146 15.146v222.458c0 8.365 6.782 15.146 15.146 15.146h91.253v-252.75H15.34zM511.805 308.587c0-19.227-10.331-36.087-25.733-45.321a52.504 52.504 0 0 0 9.362-29.985c0-29.113-23.686-52.799-52.799-52.799H331.177c3.416-15.48 8.088-38.709 11.341-63.026 8.466-63.281 2.68-98.376-18.207-110.445-13.022-7.523-27.062-9.049-39.534-4.301-9.635 3.67-22.647 12.693-30.062 34.838l-29.294 76.701c-14.851 36.677-60.33 75.182-88.535 96.473V484.4C189.16 502.716 243.708 512 299.358 512h121.446c29.113 0 52.799-23.686 52.799-52.799a52.481 52.481 0 0 0-7.93-27.804c17.601-8.572 29.759-26.646 29.759-47.503a52.504 52.504 0 0 0-9.362-29.985c15.404-9.234 25.735-26.095 25.735-45.322z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>'

  // Updated removeProductEvent function
const removeProductEvent = async (removeBtnElement) => {
  // 'removeBtnElement' is the element that was clicked (the remove button)
  // Find the product container element (adjust the selector if needed)
  const productElement = removeBtnElement.closest(".tt-product-list");
  if (!productElement) return;

  // Get the product ID from the element's data attribute
  const productId = removeBtnElement.getAttribute("data-id");

  try {
    // Call your API to remove the product from the database
    const result = await removeProductApi(productId, window.customerExist ? false : true, /* pass category id if needed */);
    
    if (result.status === 200) {
      // Successfully removed from database, so now update the UI

      // Remove the product element from the DOM
      productElement.remove();

      // Update the wishlist count without re-rendering everything
      const countElems = document.querySelectorAll(".wishlist-total-count");
      countElems.forEach((el) => {
        let count = parseInt(el.innerHTML) || 0;
        count = count > 0 ? count - 1 : 0;
        el.innerHTML = count;
        el.style.display = count > 0 ? "flex" : "none";
      });
      
      // Optionally, you can show a toast message or log success:
      console.log("Product removed successfully.");
    } else {
      console.error("Failed to remove product:", result);
    }
  } catch (error) {
    console.error("Error removing product:", error);
  }
};



// Cookie Handling Utility
const techno_setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

const techno_getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=');
        return parts[0] === name ? parts[1] : r;
    }, '');
};

// Enable guest wishlist transfer to customer data
document.addEventListener('DOMContentLoaded', async () => {
    if (!window?.customerExist) return; // Exit if customer does not exist

    const guestUserId = techno_getCookie("techno_guest_user_id");
    if (!guestUserId) return; // Exit if no guest user data is found

    try {
        await moveGuestToCustomerOnLogin(guestUserId); // Migrate guest wishlist to customer account

        // Function to delete multiple cookies
        const deleteCookies = (...cookies) => {
            cookies.forEach(name => {
                document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
            });
        };

        // Clear guest cookies
        deleteCookies("wishlist_category", "wishlist", "techno_guest_user_id");
    } catch (error) {
        console.error("Error handling guest mode:", error);
    }
});

const getMainButtonClass = (buttonSty) => {
    const buttonClasses = {
        1: "tt-icon-border",
        2: "tt-border",
        3: "tt-icon-fill",
        4: "tt-fill",
        5: "tt-icon-text",
        6: "tt-text",
        7: "tt-only-icon"
    };
    return buttonClasses[buttonSty] || "";
};

 const techno_formatMoney = (amount, format = window.money_format) => {
    if (typeof amount === "string") amount = amount.replace(".", "");
    if (isNaN(amount) || amount == null) return "0";

    const formatNumber = (value, decimals = 2, thousandsSep = ",", decimalSep = ".") => {
        value = (value / 100).toFixed(decimals);
        const [intPart, decimalPart] = value.split(".");
        return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + (decimalPart ? decimalSep + decimalPart : "");
    };

    const formats = {
        amount: formatNumber(amount, 2),
        amount_no_decimals: formatNumber(amount, 0),
        amount_with_comma_separator: formatNumber(amount, 2, ".", ","),
        amount_with_space_separator: formatNumber(amount, 2, " ", ","),
        amount_with_period_and_space_separator: formatNumber(amount, 2, " ", "."),
        amount_no_decimals_with_comma_separator: formatNumber(amount, 0, ".", ","),
        amount_no_decimals_with_space_separator: formatNumber(amount, 0, " "),
        amount_with_apostrophe_separator: formatNumber(amount, 2, "'", ".")
    };

    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    return match ? format.replace(match[0], formats[match[1]] || "0") : amount;
};
 const showToastMsg = async (handle, isLocal = false) => {
    const { notification_setting, show_notification_popup, wishlistMsgWithoutCategory, wishlistMsgWithCategory } = window.wishlistMetafields;
    
    if (!show_notification_popup) return false;

    const { duration: toastDuration, notificationPlacement: className, enableBranding: brandEnable, brandText } = notification_setting;
    
    try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error("Product fetch failed");
        const product = await response.json();

        const msgTemplate = isLocal ? wishlistMsgWithoutCategory : wishlistMsgWithCategory;
        let msg = msgTemplate?.replace("##", product.title) || `<strong>${product.title}</strong> has been added successfully`;

        if (!isLocal && msgTemplate) {
            msg = msg.replace("$$", product.listName || "your wishlist");
        }

        const divEle = document.createElement("div");
        divEle.className = `wishlist-toast-msg-wrap tt-position ${className}`;
        
        divEle.innerHTML = `
            <div class="wishlist-toast-msg">
                <div class="left-side-img">
                    <img src="${product.featured_image}" alt="${product.title}" />
                </div>
                <div class="right-side-content">
                    <p class="wishlist-product-toast-msg wishlist-p-tag">${msg}</p>
                    ${brandEnable ? `<p class="wishlist-branding-wrap wishlist-p-tag">${brandText}</p>` : ""}
                </div>
            </div>
        `;

        document.body.append(divEle);

        setTimeout(() => {
            document.querySelectorAll(".wishlist-toast-msg-wrap").forEach(ele => ele.remove());
        }, Number(toastDuration) * 1000);

    } catch (error) {
        console.error("Error displaying toast message:", error);
    }
};
const wishlistPopupOpen = (flag = false) => {
    const popupWrap = document.querySelector(".tt-wishlist-details-popup");
    if (!popupWrap) return;

    const { wishlist_module: module } = window.wishlistMetafields.button_setting;

    if (module === "drawer") popupWrap.classList.add("drawer");

    popupWrap.classList.toggle("active", !flag);
    document.body.classList.toggle("tt-overflow-hidden", !flag);
};

 const setWishlistAPIData = async () => {
    const { button_setting, category_enable, language2 } = window.wishlistMetafields;
    const { wishlist_module: module } = button_setting;
    const emptyWishlistMsg = language2.empty_wishlist;

    const fontSizeMultiplier = module === "page" ? 0.75 : 1;
    const mainWrap = document.querySelector(".tt-wishlist-details-main");
    const cartMainWrap = document.querySelector(".tt-wishlist-save-for-later");

    if (!mainWrap) return;

    mainWrap.style.setProperty("--tt-wishlist-font-multipler", fontSizeMultiplier);
    if (cartMainWrap) cartMainWrap.style.setProperty("--tt-wishlist-font-multipler", fontSizeMultiplier);

    const contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
    const cartContentWrap = cartMainWrap?.querySelector(".tt-wishlist-details-content");

    try {
        const categoriesDetails = await getCategoriesDetailsApi();
        if (categoriesDetails.status !== 200) {
            contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
            return;
        }

        let { data } = categoriesDetails;
        if (!data?.length) {
            contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
            return;
        }

        const saveCategory = data.find(category => category.category_name === "Save for later");
        data = data.filter(category => category.category_name !== "Save for later");

        if (!category_enable && window.customerExist) {
            data.forEach((category, index) => {
                if (index !== 0) {
                    data[0].details = [...data[0].details, ...category.details];
                    category.details = [];
                }
            });
        }

        let tabHeader = "";
        let tabContent = "";
        let count = 0;

        data.forEach((category, index) => {
            const categoryRemoveBtn = window.isWishlistSharedPage ? "" : `
                <button type="button" class="tt-category-remove" data-cid="${category.category_id}">
                    ${wishlistDeleteIcon}
                </button>
            `;

            tabHeader += `
                <li class="${index === 0 ? "active" : ""}" data-tab="tab${index}">
                    <button type="button" class="tt-tab-title" data-tab="tab${index}">
                        ${category.category_name}
                    </button>
                    ${categoryRemoveBtn}
                </li>
            `;

            let productList = category.details.map(product => {
                count++;
                return `<div class="tt-product-list" data-id="${product.product_id}" data-handle="${product.handle}"></div>`;
            }).join("") || `<p style="text-align:center;">${emptyWishlistMsg}</p>`;

            tabContent += `
                <div class="${index === 0 ? "active" : ""} tab-content-inner-wrap" data-tab="tab${index}">
                    ${productList}
                </div>
            `;
        });

        if (contentWrap) {
            contentWrap.innerHTML = `
                <ul class="tt-tab-header-wrap">${tabHeader}</ul>
                <div class="tt-tab-content-wrap">${tabContent}</div>
            `;
        }

        if (saveCategory?.details.length) {
            const saveProductList = saveCategory.details.map(product => `
                <div class="tt-product-list tt-sfl" data-handle="${product.handle}"></div>
            `).join("");

            if (cartContentWrap) {
                cartContentWrap.innerHTML = `
                    <div class="tt-wishlist-details-main save_for_later_cat">
                        <ul class="tt-tab-header-wrap">
                            <li class="active">
                                <button type="button" class="tt-tab-title">Save for later</button>
                            </li>
                        </ul>
                        <div class="tt-tab-content-wrap">
                            <div class="tab-content-inner-wrap active">${saveProductList}</div>
                        </div>
                    </div>
                `;
            }
        } else if (cartContentWrap) {
            cartContentWrap.innerHTML = "";
        }

        updateProductContent();

        if (!category_enable && window.customerExist) {
            document.querySelectorAll(".tt-tab-header-wrap").forEach(item => {
                if (!item.closest(".tt-wishlist-save-for-later")) {
                    item.classList.add("tt-hide");
                }
            });
        }

        wishlistUpdateCount(count);
    } catch (error) {
        console.error("Error fetching wishlist data:", error);
    }
};

 const setWishlistLocalData = async (flag) => {
    const { button_setting, language2 } = window.wishlistMetafields;
    const { wishlist_module: module } = button_setting;
    const emptyWishlistMsg = language2.empty_wishlist;
    const fontSizeMultiplier = module === "page" ? 0.75 : 1;

    const mainWrap = document.querySelector(".tt-wishlist-details-main");
    if (!mainWrap) return;

    mainWrap.style.setProperty("--tt-wishlist-font-multipler", fontSizeMultiplier);

    const contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
    if (!contentWrap) return;

    let count = 0;
    let tabContent = "";

    try {
        let productsData = techno_getCookie("wishlist");
        if (productsData) {
            productsData = JSON.parse(productsData);

            if (Array.isArray(productsData) && productsData.length > 0) {
                tabContent = productsData.map(product => `
                    <div class="tt-product-list" data-handle="${product.p_handle}"></div>
                `).join("");

                if (!tabContent) {
                    tabContent = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
                }

                contentWrap.innerHTML = `
                    <div class="tt-tab-content-wrap">
                        <div class="active tab-content-inner-wrap" data-tab="tab0">
                            ${tabContent}
                        </div>
                    </div>
                `;

                updateProductContent();
                count = productsData.length;
            } else {
                contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
            }
        } else {
            contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
        }

        if (flag) {
            contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
        }

        wishlistUpdateCount(count);
    } catch (error) {
        console.error("Error loading local wishlist data:", error);
        contentWrap.innerHTML = `<p style="text-align:center;">${emptyWishlistMsg}</p>`;
    }
};
  const wishlistUpdateCount = (count = 0) => {
    var vuoto = document.querySelector('.header-wishlist #vuoto');
    var vuoto2 = document.querySelector('.header-wishlist #vuoto2');
    
    if (count === 0) {
      if (vuoto) vuoto.style.display = 'block'; // or use '' to reset to default
      if (vuoto2) vuoto2.style.display = 'none';
    } else {
      if (vuoto) vuoto.style.display = 'none';
      if (vuoto2) vuoto2.style.display = 'block'; // or use '' to reset to default
    }

    document.querySelectorAll(".wishlist-total-count").forEach(el => {
        el.style.display = count > 0 ? "flex" : "none";
        el.innerHTML = count;
    });
};

const wishlistContent = () => {
    if (this.customerExist) {
        setWishlistAPIData();
    } else {
        setWishlistLocalData(window.wishlistMetafields.guest_wishlist !== 1);
    }
};

const updateProductContent = (flag = false, isTrending) => {
    const allProductArr = [...document.querySelectorAll(".tt-product-list")]
        .filter(ele => isTrending || !ele.closest(".tt-wishlist-trending-wrap"));

    fetchProductDetails(allProductArr, flag);
};

const fetchProductDetails = async (products, flag) => {
  if (!products || products.length === 0) {
    window.ttWishlistClickEvents();
    if (flag) {
      // If needed, initialize trending widget here.
    }
    return;
  }

  // Destructure configuration for buttons/colors.
  const {
    btn_move_to_cart: atcText,
    btn_oos_text: oosText,
    btn_text_color: atcColor,
    oos_text_color: oosColor,
    btn_bg_color: atcColorBg,
    oos_bg_color: oosColorBg
  } = window.wishlistMetafields.language2;

  // Find the container (adjust the selector if needed)
  const container = document.querySelector(".tt-wishlist-details-content");
  let globalLoader;
  if (container) {
    globalLoader = document.createElement("div");
    globalLoader.classList.add("global-loading-icon");
    // Customize the markup and styling as needed.
    globalLoader.innerHTML = `<span class="spinner"><img src="/cdn/shop/t/61/assets/loader.gif?v=92049173152441053881740395622"></span>`;
    container.appendChild(globalLoader);
  }

  // Create an array of promises—one for each product element.
  const productPromises = products.map(async (currProduct) => {
    const pHandle = currProduct.getAttribute("data-handle");
    const pid = currProduct.getAttribute("data-id");
    // Set CSS custom properties for the product element.
    currProduct.style.setProperty("--tt-atc-btn-color", atcColor);
    currProduct.style.setProperty("--tt-atc-btn-bg", atcColorBg);
    currProduct.style.setProperty("--tt-oos-btn-color", oosColor);
    currProduct.style.setProperty("--tt-oos-btn-bg", oosColorBg);
    
    try {
      const response = await fetch(`/products/${pHandle}.js`);
      if (response.ok) {
        const product = await response.json();
        let variantHtml = "";
        let defaultVariant = false;
        let atcButton = product.available;
        if (!product.available) {
          defaultVariant = true;
          atcButton = false;
        }
        if (product.available && product.variants && product.variants.length > 0) {
          product.variants.forEach(variant => {
            if (variant.title === 'Default Title') {
              defaultVariant = true;
              if (!variant.available) atcButton = false;
            }
            // If variants are disabled in settings, always use default.
            if (window.wishlistMetafields.enable_variants == 0) defaultVariant = true;
            variantHtml += `<option value="${variant.id}" data-price="${variant.price}" data-available="${variant.available}" ${variant.available ? "" : "disabled"}>${variant.title}</option>`;
          });
        }
        let atcButtonHtml = "";
        if (atcButton) {
          atcButtonHtml = `<button type="button" class="tt-product-atc-main" data-id="${product.id}">${atcText}</button>`;
          if (window.wishlistMetafields.show_add_to_cart_btn == 0) atcButtonHtml = "";
        } else {
          atcButtonHtml = `<button type="button" class="tt-product-atc-main" disabled data-id="${product.id}">${oosText}</button>`;
          if (window.wishlistMetafields.show_oos_btn == 0) atcButtonHtml = "";
        }
        let qtyHtml = '<input class="tt-qty-input" name="tt-quantity" type="hidden" value="1">';
        if (window.wishlistMetafields.qty_enable == 1) {
          qtyHtml = `
            <div class="tt-qty-input">
              <p class="tt-qty-label">Quantity</p>
              <div class="tt-qty-input-inner">
                <button class="tt-qty-count tt-qty-count--minus" data-action="minus" type="button">-</button>
                <input class="tt-product-qty" type="number" name="tt-quantity" min="1" value="1">
                <button class="tt-qty-count tt-qty-count--add" data-action="add" type="button">+</button>
              </div>
            </div>
          `;
        }
        let vendorHtml = "";
        if (window.wishlistMetafields.show_vendor_name == 1) {
          vendorHtml = `<div class="tt-product-vendor-text">${product.vendor}</div>`;
        }
        let productRemoveBtn = "";
        if (!window.isWishlistSharedPage) {
          productRemoveBtn = `<div class="tt-product-remove-wishlist" data-id="${product.id}">${wishlistPopupCloseIcon}</div>`;
        }
        const productHtml = `
          <a href="${product.url}" class="tt-image-a">
            <div class="tt-image-wrap">
              <img src="${product.featured_image}" alt="${product.title}" />
            </div>
          </a>
          <div class="tt-product-content">
            ${vendorHtml}
            <a href="${product.url}" class="tt-product-title_vsb product-item__product-title product-item__product-title--truncate">
              ${product.title}
            </a>
            <div class="tt-product-price-wrap product-item__price">
              ${techno_formatMoney(product.variants[0].price)}
            </div>
            <select class="${defaultVariant ? "tt-hide" : ""}">
              ${variantHtml}
            </select>
            <div class="tt-qty-selector">
              ${qtyHtml}
            </div>
          </div>
          <div class="tt-error-msg"></div>
          <div class="tt-product-action">
            <div class="tt-atc-button-wrap">
              ${atcButtonHtml}
            </div>
            ${productRemoveBtn}
          </div>
        `;
        // Update the product element with the loaded content.
        currProduct.innerHTML = productHtml;
      } else {
        // If the fetch fails, provide a minimal product block with a remove button.
        const productRemoveBtn = `<div class="tt-product-remove-wishlist" data-id="${pid}">${wishlistPopupCloseIcon}</div>`;
        currProduct.innerHTML = `<div class="tt-product-action">${productRemoveBtn}</div>`;
        window.ttWishlistClickEvents();
        const removeBtn = document.querySelector(`.tt-product-list[data-handle="${pHandle}"] .tt-product-remove-wishlist`);
        if (removeBtn) removeBtn.click();
      }
    } catch (error) {
      console.error("Error fetching product details for", pHandle, error);
    }
  });
  
  // Wait for all fetch promises to complete.
  await Promise.all(productPromises);
  
  // Remove the global loading icon.
  if (globalLoader && container) {
    container.removeChild(globalLoader);
  }
  
  // Reattach any necessary event bindings.
  window.ttWishlistClickEvents();
  
  // If the flag is set, initialize the trending widget if required.
  if (flag) {
    const allTrendingEle = document.querySelectorAll(".super-wishlist-trending-widget .swiper");
    if (allTrendingEle.length > 0) {
      const firstParent = allTrendingEle[0].closest(".super-wishlist-trending-widget");
      const slideDesk = Number(firstParent.getAttribute("data-desktop-row"));
      const slideMob = Number(firstParent.getAttribute("data-mobile-row"));
      const slideArrow = firstParent.getAttribute("data-arrow");
      const slideAuto = firstParent.getAttribute("data-auto-rotate");
      const sliderSettings = {
        slidesPerView: slideMob,
        loop: false,
        breakpoints: {
          300: { slidesPerView: slideMob },
          767: { slidesPerView: slideDesk }
        }
      };
      if (slideAuto) sliderSettings.autoplay = { delay: 4000 };
      allTrendingEle.forEach(ele => {
        const mainParent = ele.closest(".super-wishlist-trending-widget");
        mainParent.style.opacity = 1;
        if (slideArrow) {
          sliderSettings.navigation = {
            nextEl: ele.querySelector(".swiper-button-next"),
            prevEl: ele.querySelector(".swiper-button-prev")
          };
        }
        new Swiper(ele, sliderSettings);
      });
    }
  }
};

const handleMissingProduct = (currProduct, pHandle, pid) => {
    if (!pHandle) return;
    const productRemoveBtn = `<div class="tt-product-remove-wishlist" data-id=${pid}>${wishlistPopupCloseIcon}</div>`;
    currProduct.innerHTML = `<div class="tt-product-action">${productRemoveBtn}</div>`;
    window.ttWishlistClickEvents();

    const removeBtn = document.querySelector(`.tt-product-list[data-handle="${pHandle}"] .tt-product-remove-wishlist`);
    if (removeBtn) removeBtn.click();
};

const initializeTrendingSliders = () => {
    const allTrendingEle = document.querySelectorAll(".super-wishlist-trending-widget .swiper");
    if (!allTrendingEle.length) return;

    let firstParent = allTrendingEle[0].closest(".super-wishlist-trending-widget");
    let slideDesk = Number(firstParent.getAttribute("data-desktop-row"));
    let slideMob = Number(firstParent.getAttribute("data-mobile-row"));
    let slideArrow = firstParent.getAttribute("data-arrow");
    let slideAuto = firstParent.getAttribute("data-auto-rotate");

    let sliderSettings = {
        slidesPerView: slideMob,
        loop: false,
        breakpoints: {
            300: { slidesPerView: slideMob },
            767: { slidesPerView: slideDesk }
        }
    };

    if (slideAuto) sliderSettings.autoplay = { delay: 4000 };
    allTrendingEle.forEach(ele => {
        let mainParent = ele.closest(".super-wishlist-trending-widget");
        mainParent.style.opacity = 1;
        if (slideArrow) sliderSettings.navigation = {
            nextEl: ele.querySelector(".swiper-button-next"),
            prevEl: ele.querySelector(".swiper-button-prev")
        };
        new Swiper(ele, sliderSettings);
    });
};

const getCategoriesApi = async () => {
    try {
        const url = `${window.wishlistUrl}get/all?customer_id=${window.customerId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: { shop: window.shop_domin }
        });

        if (!response.ok) throw new Error(`Failed to fetch categories: ${response.statusText}`);

        const getCategories = await response.json();
        window.getCategoriesData = getCategories;
        return getCategories;
    } catch (error) {
        console.error("Error fetching categories:", error);
        return null; // Return null to handle failures gracefully
    }
};

   const getCategoriesDetailsApi = async () => {
    try {
        const url = `${window.wishlistUrl}get/product-details?customer_id=${window.customerId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: { shop: window.shop_domin }
        });

        if (!response.ok) throw new Error(`Failed to fetch category details: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error fetching category details:", error);
        return null; // Return null to handle errors gracefully
    }
};

 const addProductInCategoryApi = async (catId, id, guestMode) => {
    try {
        const data = {
            customer_id: guestMode ? "" : window.customerId,
            category_id: catId,
            product_id: id,
            isGuest: guestMode
        };

        const response = await fetch(`${window.wishlistUrl}category/product-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to add product: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error adding product to category:", error);
        return null; // Return null to handle errors gracefully
    }
};

const removeProductApi = async (id, guestMode, categoryId) => {
    try {
        const data = {
            customer_id: guestMode ? "" : window.customerId,
            product_id: id,
            isGuest: guestMode,
            category_id: categoryId
        };

        const response = await fetch(`${window.wishlistUrl}category/product-delete`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to remove product: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error removing product from category:", error);
        return null; // Return null to handle errors gracefully
    }
};

const removeCategoryApi = async (id) => {
    try {
        const data = {
            customer_id: window.customerId,
            category_id: id
        };

        const response = await fetch(`${window.wishlistUrl}category/delete`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to remove category: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error removing category:", error);
        return null; // Return null to handle errors gracefully
    }
};

 const createCategoryApi = async (catName, guestCategoryId, guestMode) => {
    try {
        const data = {
            customer_id: guestMode ? "" : window.customerId,
            category_name: catName,
            customer_email: guestMode ? "" : window.customerEmail,
            customer_name: guestMode ? "" : window.customerName,
            guest_id: guestCategoryId,
            isGuest: guestMode
        };

        const response = await fetch(`${window.wishlistUrl}category/create-update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to create category: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error creating category:", error);
        return null; // Return null to handle errors gracefully
    }
};

const moveGuestToCustomerOnLogin = async (guestUserId) => {
    try {
        const data = {
            customer_id: window.customerId,
            guest_id: guestUserId,
            customer_email: window.customerEmail,
            customer_name: window.customerName
        };

        const response = await fetch(`${window.wishlistUrl}move-guest-to-customer-on-login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to move guest data: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error moving guest to customer:", error);
        return null; // Return null to handle errors gracefully
    }
};

 const cartCountApi = async () => {
    try {
        const url = `${window.wishlistUrl}analytics`;
        const data = { cart_count: 1 };

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to fetch cart count: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error fetching cart count:", error);
        return null; // Return null to handle errors gracefully
    }
};

  const pageCountApi = async () => {
    try {
        const url = `${window.wishlistUrl}analytics`;
        const data = { page_count: 1 };

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to update page count: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error updating page count:", error);
        return null; // Return null to handle errors gracefully
    }
};

 const submitVoteApi = async (pId, flag) => {
    try {
        const url = `${window.wishlistUrl}product-vote`;
        const data = {
            customer_id: window.customerId,
            product_id: pId,
            vote_count: flag ? 1 : 0
        };

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                shop: window.shop_domin
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) throw new Error(`Failed to submit vote: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error submitting vote:", error);
        return null;
    }
};

const getVoteDataApi = async (pId) => {
    try {
        const url = `${window.wishlistUrl}product-vote?product_id=${pId}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                shop: window.shop_domin
            }
        });

        if (!response.ok) throw new Error(`Failed to fetch vote data: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error fetching vote data:", error);
        return null;
    }
};

const getCustomerVoteDataApi = async (pId) => {
    try {
        const url = `${window.wishlistUrl}product-vote?product_id=${pId}&customer_id=${window.customerId}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                shop: window.shop_domin
            }
        });

        if (!response.ok) throw new Error(`Failed to fetch customer vote data: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error fetching customer vote data:", error);
        return null;
    }
};

const trendingApi = async () => {
    try {
        const url = `${window.wishlistUrl}trending-wishlist`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                shop: window.shop_domin
            }
        });

        if (!response.ok) throw new Error(`Failed to fetch trending wishlist: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error fetching trending wishlist:", error);
        return null;
    }
};

const removeFromCartApi = async (id) => {
    try {
        const updates = { [id]: 0 };

        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ updates })
        });

        if (!response.ok) throw new Error(`Failed to remove item from cart: ${response.statusText}`);

        await response.json();
        window.location.reload();
    } catch (error) {
        console.error("Error removing item from cart:", error);
    }
};

const ajaxAddToCart = async (items) => {
    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error(`Failed to add items to cart: ${response.statusText}`);

        return await response.json();
    } catch (error) {
        console.error("Error adding items to cart:", error);
        return null; // Return null to handle errors gracefully
    }
};

class WishlistPDP {
    constructor() {
        this.setAllData();
    }

    setAllData = async () => {
        await this.setGuest();

        // Assigning global properties
        this.storeId = window.shop_domin;
        this.wishlistMeta = window.wishlistMetafields;
        this.customerExist = window.customerExist;
        this.customerName = window.customerName;
        this.customerEmail = window.customerEmail;
        this.wishlistUrl = window.wishlistUrl;
        this.wishlistPageUrl = "/apps/wishlist/wishlist-landing";
        window.isWishlistSharedPage = false;

        // Handle shared wishlist scenario
        if (this.customerExist) {
            this.customerId = window.customerId;
        } else {
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has("q") && window.location.pathname.includes("wishlist-share")) {
                window.isWishlistSharedPage = true;
                this.customerExist = true;
                window.customerExist = true;
                this.customerId = searchParams.get("q");
                window.customerId = this.customerId;
            }
        }

        this.init();

        // Setup trending wishlist if enabled
        if (this.wishlistMeta.show_trending_wishlist == "1" || this.wishlistMeta.show_trending_wishlist == 1) {
            this.trendingWishlistSetup();
        }

        // Event listener for wishlist button clicks
        document.addEventListener("click", (e) => {
            const target = e.target.closest(".tt-wishlist-plp-btn-main");
            if (target) this.plpButtonClick(target);
        });
    };


    clickEvents = () => {
        // Product Details Page Wishlist Button
        document.querySelectorAll(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap")
            .forEach(item => item.addEventListener("click", this.pdpButtonClick));
    
        // Category Popup Close Button
        const categoryPopupClose = document.querySelector(".wishlist-create-category-popup .tt-category-close");
        categoryPopupClose?.addEventListener("click", () => this.categoryPopupShow(true));
    
        // Add Product in Category
        document.querySelectorAll(".wishlist-create-category-popup .tt-form-group .tt-add-wishlist")
            .forEach(ele => ele.addEventListener("click", this.addProductInCategory));
    
        // Create Category Event
        const createCategory = document.querySelector(".wishlist-create-category-popup .tt-form-new-group .tt-add-wishlist");
        createCategory?.addEventListener("click", this.createCategoryEvent);
    
        // Floating Wishlist & Widget Buttons
        [".wishlist-floting-btn-wrap", ".wishlist-page-widget"].forEach(btnClass => {
            document.querySelectorAll(btnClass).forEach(ele => ele.addEventListener("click", this.wishlistBtnEvent));
        });
    
        // Tab Change Event
        document.querySelectorAll(".tt-tab-header-wrap .tt-tab-title")
            .forEach(ele => ele.addEventListener("click", this.tabChangeEvent));
    
        // Wishlist Details Popup Close Button
        document.querySelector(".tt-wishlist-details-popup .tt-details-close")
            ?.addEventListener("click", this.detailsPopupCloseEvent);
    
        // Wishlist Details Popup Overlay
        document.querySelector(".tt-wishlist-details-popup .tt-popup-overlay")
            ?.addEventListener("click", this.detailsPopupCloseEvent);
    
        // Share Button
        document.querySelector(".tt-wishlist-share-btn")
            ?.addEventListener("click", () => this.shareButtonEvent());
    
        // Share Popup Close Button
        document.querySelector(".tt-share-wishlist-popup .tt-share-wishlist-close")
            ?.addEventListener("click", () => this.shareButtonEvent(true));
    
        // Share Popup Overlay
        document.querySelector(".tt-share-wishlist-popup .tt-popup-overlay")
            ?.addEventListener("click", () => this.shareButtonEvent(true));
    
        // Category Remove Event
        document.querySelectorAll(".tt-wishlist-details-main .tt-category-remove")
            .forEach(ele => ele.addEventListener("click", e => this.removeCategoryEvent(e.currentTarget)));
    
        // Remove Product from Wishlist
        document.querySelectorAll(".tt-product-remove-wishlist").forEach(btn => {
          btn.removeEventListener("click", () => removeProductEvent(btn));
          btn.addEventListener("click", () => removeProductEvent(btn));
        });

    
        // Add to Cart Event
        document.querySelectorAll(".tt-product-list .tt-product-atc-main")
            .forEach(ele => ele.addEventListener("click", e => this.addToCartEvent(e.currentTarget)));
    
        // Wishlist Product Vote Button
        document.querySelectorAll(".wishlist-pdp-btn-main .tt-vote-btn-wrap")
            .forEach(ele => ele.addEventListener("click", this.voteButtonEvent));
    
        // Copy Button Event
        document.querySelectorAll(".ttcopybtn")
            .forEach(ele => ele.addEventListener("click", this.copyButtonEvent));
    
        // Quantity Change Events
        document.querySelectorAll(".tt-product-list .tt-qty-count")
            .forEach(ele => ele.addEventListener("click", this.qtyClickEvent));
    
        document.querySelectorAll(".tt-product-list .tt-product-qty")
            .forEach(ele => ele.addEventListener("change", e => this.qtyInputChangeEvent(e.currentTarget)));
    
        // Product Variant Change Event
        document.querySelectorAll(".tt-wishlist-details-main .tt-product-content select")
            .forEach(ele => ele.addEventListener("change", e => this.variantChangeEvent(e.currentTarget)));
    };

   pdpButtonClick = (e) => {
      const that = e.currentTarget;
      const parent = that.closest(".wishlist-pdp-btn-main");
      if (!parent) return;
  
      const id = parseInt(parent.getAttribute("data-pid"));
      const handle = parent.getAttribute("data-handle");
      const categoryEnable = this.wishlistMeta.category_enable;
  
      if (this.customerExist) {
          if (that.classList.contains("active")) {
              this.deleteProduct(id);
          } else if (categoryEnable) {
              this.categoryPopupShow();
              document.querySelector(".wishlist-create-category-popup-main")?.setAttribute("data-pid", id);
              document.querySelector(".wishlist-create-category-popup-main")?.setAttribute("data-handle", handle);
          } else {
              this.addProductInWithoutCategory(id, handle);
          }
      } else {
          if (window.wishlistMetafields.guest_wishlist == 1) {
              that.classList.contains("active") ? this.deleteProductLocal(id) : this.addToWishlistLocal(id, handle);
          } else {
              location.href = "/account/login";
          }
      }
  };

  plpButtonClick = (e) => {
      let that = e.currentTarget || e.querySelector(".wishlist-plp-btn-wrap");
      if (!that) return;
  
      let parent = that.closest(".tt-wishlist-plp-btn-main");
      if (!parent) return;
  
      const isCartProduct = parent.classList.contains("tt-cart-btn");
      const vId = isCartProduct ? parseInt(parent.getAttribute("data-vid")) : "";
      const id = parseInt(parent.getAttribute("data-pid"));
      const handle = parent.getAttribute("data-handle");
      const categoryEnable = this.wishlistMeta.category_enable;
  
      // Update "Saving..." text if it's a cart button
      if (isCartProduct) {
          that.querySelectorAll("span")?.forEach(ele => ele.innerHTML = "Saving...");
      }
  
      if (this.customerExist) {
          if (!isCartProduct && that.classList.contains("active")) {
              this.deleteProduct(id);
          } else if (isCartProduct) {
              this.addProductInSavedForLater(id, vId, handle);
          } else if (categoryEnable) {
              this.categoryPopupShow();
              const popupWrap = document.querySelector(".wishlist-create-category-popup-main");
              popupWrap?.setAttribute("data-pid", id);
              popupWrap?.setAttribute("data-handle", handle);
          } else {
              this.addProductInWithoutCategory(id, handle);
          }
      } else {
          if (window.wishlistMetafields.guest_wishlist == 1) {
              if (!isCartProduct && that.classList.contains("active")) {
                  this.deleteProductLocal(id);
              } else {
                  this.addToWishlistLocal(id, handle);
                  if (isCartProduct) removeFromCartApi(vId);
              }
          } else {
              location.href = "/account/login";
          }
      }
  };

    addProductInSavedForLater = async (id, vId, handle) => {
      if (!window.getCategoriesData) return;
  
      let catId = window.getCategoriesData.data.find(ele => ele.category_name === "Default Category")?.category_id;
  
      if (!catId) {
          const newCategory = await createCategoryApi("Default Category");
          if (newCategory?.status === 200) {
              const updatedCategories = await getCategoriesApi();
              catId = updatedCategories?.data?.find(ele => ele.category_name === "Default Category")?.category_id;
          }
      }
  
      if (id && catId) {
          const addProduct = await addProductInCategoryApi(catId, id);
          if (addProduct?.status === 200) removeFromCartApi(vId);
      }
  };

   addProductInSaved = async (id, vId, handle) => {
      if (!window.getCategoriesData) return;
  
      let catId = window.getCategoriesData.data.find(ele => ele.category_name === "Save for later")?.category_id;
  
      if (!catId) {
          const newCategory = await createCategoryApi("Save for later");
          if (newCategory?.status === 200) {
              const updatedCategories = await getCategoriesApi();
              catId = updatedCategories?.data?.find(ele => ele.category_name === "Save for later")?.category_id;
          }
      }
  
      if (id && catId) {
          const addProduct = await addProductInCategoryApi(catId, id);
          if (addProduct?.status === 200) removeFromCartApi(vId);
      }
  };

  addProductInWithoutCategory = async (id, handle) => {
      if (!window.getCategoriesData) return;
  
      let catId = window.getCategoriesData.data.find(ele => ele.category_name === "Default Category")?.category_id;
  
      if (!catId) {
          const newCategory = await createCategoryApi("Default Category");
          if (newCategory?.status === 200) {
              const updatedCategories = await getCategoriesApi();
              catId = updatedCategories?.data?.find(ele => ele.category_name === "Default Category")?.category_id;
          }
      } else {
          const updatedCategories = await getCategoriesApi();
          catId = updatedCategories?.data?.find(ele => ele.category_name === "Default Category")?.category_id;
      }
  
      if (id && catId) {
          const addProduct = await addProductInCategoryApi(catId, id);
          if (addProduct?.status === 200) {
              this.categoryPopupShow(true);
              showToastMsg(handle, true);
              this.getCategoryAllData();
              wishlistContent();
          }
      }
  };

  copyButtonEvent = (e) => {
      const copyUrl = e.target.closest(".tt-share-input-url")?.querySelector(".tt-share-input")?.value;
      if (copyUrl) {
          navigator.clipboard.writeText(copyUrl);
          e.target.classList.add("active");
      }
  };
  
  qtyClickEvent = (e) => {
      const parent = e.target.closest(".tt-qty-input");
      if (!parent) return;
  
      const inputEle = parent.querySelector(".tt-product-qty");
      if (!inputEle) return;
  
      const qtyMin = parseInt(inputEle.getAttribute("min")) || 1;
      let qty = parseInt(inputEle.value) || qtyMin;
      const actionType = e.target.getAttribute("data-action");
  
      if (actionType === "add") {
          qty += 1;
          parent.querySelector(".tt-qty-count--minus")?.removeAttribute("disabled");
      } else {
          qty = Math.max(qtyMin, qty - 1);
          if (qty === qtyMin) parent.querySelector(".tt-qty-count--minus")?.setAttribute("disabled", true);
      }
  
      inputEle.value = qty;
  };
  
  qtyInputChangeEvent = (that) => {
      const minusBtn = that.closest(".tt-qty-input")?.querySelector(".tt-qty-count--minus");
      if (!minusBtn) return;
  
      const qtyMin = parseInt(that.getAttribute("min")) || 1;
      let qty = parseInt(that.value) || qtyMin;
  
      if (isNaN(qty) || qty <= qtyMin) {
          that.value = qtyMin;
          minusBtn.setAttribute("disabled", true);
      } else {
          that.value = qty;
          minusBtn.removeAttribute("disabled");
      }
  };

  voteButtonEvent = async (e) => {
        if (!this.wishlistMeta.vote_btn.enable || !this.customerExist) return false;
    
        const that = e.currentTarget;
        const pId = that.closest(".wishlist-pdp-btn-main")?.getAttribute("data-pid");
        if (!pId) return;
    
        const flag = !that.classList.contains("active");
        if (flag) that.classList.add("active");
    
        const response = await submitVoteApi(pId, flag);
        if (response?.status === 200) this.setupVoteBtn();
    };
    
    addProductInCategory = async (e) => {
        const parent = e.target.closest(".wishlist-create-category-popup-main");
        if (!parent) return;
    
        const id = parent.getAttribute("data-pid");
        const handle = parent.getAttribute("data-handle");
        const catId = e.target.getAttribute("cat-id");
    
        if (id && catId) {
            const response = await addProductInCategoryApi(catId, id);
            if (response?.status === 200) {
                this.categoryPopupShow(true);
                showToastMsg(handle, true);
                this.getCategoryAllData();
                wishlistContent();
            }
        }
    };
    
    detailsPopupCloseEvent = () => wishlistPopupOpen(true);
    
    createCategoryEvent = async (e) => {
        const catName = e.target.closest(".wishlist-create-category-popup-main")?.querySelector(".tt-form-new-group input")?.value;
        if (!catName) return;
    
        const response = await createCategoryApi(catName);
        if (response?.status === 200) this.createCategory();
    };
    
    wishlistBtnEvent = () => {
        const module = wishlistMetafields.button_setting.wishlist_module;
        if (module === "popup" || module === "drawer") {
            if (!document.querySelector(".tt-wishlist-landing-page-main")) {
                pageCountApi();
                wishlistPopupOpen();
            }
        } else {
            location.href = "/apps/wishlist/wishlist-landing";
        }
    };

   tabChangeEvent = (e) => {
        const tabId = e.target.getAttribute("data-tab");
        if (!tabId) return;
    
        document.querySelectorAll(".tt-tab-header-wrap li").forEach(ele =>
            ele.classList.toggle("active", ele.getAttribute("data-tab") === tabId)
        );
    
        document.querySelectorAll(".tt-tab-content-wrap .tab-content-inner-wrap").forEach(ele =>
            ele.classList.toggle("active", ele.getAttribute("data-tab") === tabId)
        );
    };


   shareButtonEvent = (flag) => {
        const popupWrap = document.querySelector(".tt-share-wishlist-popup");
        if (!popupWrap) return;
    
        document.body.classList.toggle("tt-overflow-hidden", !flag);
        popupWrap.classList.toggle("active", !flag);
    };
    
    removeCategoryEvent = async (e) => {
        const id = e?.getAttribute("data-cid");
        if (!id) return;
    
        const response = await removeCategoryApi(id);
        if (response?.status === 200) {
            this.createCategory();
            wishlistContent();
        }
    };
    
 
   addToCartEvent = async (e) => {
        e.innerHTML = "Adding...";
    
        const parent = e.closest(".tt-product-list");
        const pId = e.getAttribute("data-id");
        const selectedOption = parent?.querySelector(".tt-product-content select")?.selectedOptions[0];
    
        if (!selectedOption) return;
    
        const availability = selectedOption.getAttribute("data-available") === "true";
        const id = parseInt(selectedOption.getAttribute("value"));
        let quantity = parseInt(parent?.querySelector("input[name=tt-quantity]")?.value) || 1;
        const atcText = window.wishlistMetafields.language2.btn_move_to_cart;
    
        if (!availability) return;
    
        const atc = await ajaxAddToCart([
            {
                id,
                quantity,
                properties: { _is_wishlist_product: true }
            }
        ], true);
    
        if (atc?.status === 422) {
            parent.querySelector(".tt-error-msg").innerHTML = atc.description;
            e.innerHTML = atcText;
            setTimeout(() => {
                parent.querySelector(".tt-error-msg").innerHTML = "";
            }, 5000);
            return false;
        }
    
        cartCountApi();
    
        if (window.wishlistMetafields.remove_product_after_cart === 1) {
            e.innerHTML = atcText;
    
            if (this.customerExist) {
                if (window.isWishlistSharedPage) return false;
                const response = await removeProductApi(pId);
                if (response?.status === 200) {
                    wishlistContent();
                    this.createCategory();
                }
                if (window.wishlistMetafields.stay_on_wishlist_after_cart === 0) location.href = "/cart";
            } else if (window.wishlistMetafields.guest_wishlist === 1) {
                this.deleteProductLocal(pId);
                wishlistContent();
            }
        } else {
            e.innerHTML = "Added To Cart";
            setTimeout(function(params) {
              e.innerHTML = atcText;
            },2000)
            if (window.wishlistMetafields.stay_on_wishlist_after_cart === 0) location.href = "/cart";
        }
    };

    variantChangeEvent = (e) => {
          const parent = e.closest(".tt-product-list");
          if (!parent) return;
      
          const price = e.selectedOptions[0]?.getAttribute("data-price");
          const priceEle = parent.querySelector(".tt-product-price-wrap");
          if (priceEle) priceEle.innerHTML = techno_formatMoney(price);
      };
      
      categoryPopupShow = (flag) => {
          const popupWrap = document.querySelector(".wishlist-create-category-popup-main");
          if (!popupWrap) return;
      
          document.body.classList.toggle("tt-overflow-hidden", !flag);
          popupWrap.classList.toggle("active", !flag);
      };
      
      getCategoryAllData = async (data) => {
          let getCategories = data || await getCategoriesApi();
          if (!getCategories || getCategories?.status !== 200) return false;
      
          let availablePro = [];
      
          if (getCategories.data?.length > 0) {
              getCategories.data.forEach(item => {
                  availablePro = availablePro.concat(item.product_ids);
              });
      
              document.querySelectorAll(".wishlist-pdp-btn-main").forEach(item => {
                  const itemId = item.getAttribute("data-pid")?.toString();
                  item.querySelector(".wishlist-pdp-btn-wrap")?.classList.toggle("active", availablePro.includes(itemId));
              });
      
              document.querySelectorAll(".tt-wishlist-plp-btn-main").forEach(item => {
                  const itemId = item.getAttribute("data-pid")?.toString();
                  item.querySelector(".wishlist-plp-btn-wrap")?.classList.toggle("active", availablePro.includes(itemId));
              });
          } else {
              document.querySelectorAll(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap, .tt-wishlist-plp-btn-main .wishlist-plp-btn-wrap")
                  .forEach(btn => btn?.classList.remove("active"));
          }
      };

     fetchProductExistLocal = () => {
        let productsData = techno_getCookie("wishlist");
        let currProIds = new Set(); // Use Set for better lookup performance
    
        if (productsData) {
            try {
                productsData = JSON.parse(productsData);
                productsData.forEach(item => currProIds.add(parseInt(item.p_id)));
            } catch (error) {
                console.error('Error parsing productsData:', error);
                productsData = []; // Reset to an empty array if JSON is invalid
            }
        } else {
            productsData = []; // Initialize as an empty array if cookie doesn't exist
        }
    
        // Function to update button states
        const updateButtonState = (selector, btnClass) => {
            document.querySelectorAll(selector).forEach(item => {
                const itemId = parseInt(item.getAttribute("data-pid"));
                item.querySelector(btnClass)?.classList.toggle("active", currProIds.has(itemId));
            });
        };
    
        // Update PDP & PLP buttons
        updateButtonState(".wishlist-pdp-btn-main", ".wishlist-pdp-btn-wrap");
        updateButtonState(".tt-wishlist-plp-btn-main", ".wishlist-plp-btn-wrap");
    };

   addToWishlistLocal = async (p_id, p_handle) => {
      let productsData = techno_getCookie("wishlist");
      let categoryData = techno_getCookie("wishlist_category");
      let guestCategoryId;
  
      try {
          productsData = productsData ? JSON.parse(productsData) : [];
          categoryData = categoryData ? JSON.parse(categoryData) : [];
  
          guestCategoryId = categoryData[0]?.category_id;
      } catch (error) {
          console.error("Error parsing wishlist cookie:", error);
          productsData = [];
          categoryData = [];
      }
  
      // Generate guest category ID if not present
      if (!guestCategoryId) {
          guestCategoryId = "CAT-" + Math.floor(Math.random() * 100000);
          techno_setCookie("wishlist_category", JSON.stringify([{ category_id: guestCategoryId }]), 100);
      }
  
      // Create guest category & add product to wishlist
      await createCategoryApi("Guest Category", guestCategoryId, true); // true = guest mode
      await addProductInCategoryApi(guestCategoryId, p_id, true); // true = guest mode
  
      // Add product to local wishlist & update cookie
      productsData.push({ p_id, p_handle });
      techno_setCookie("wishlist", JSON.stringify(productsData), 100);
  
      // Perform additional actions
      showToastMsg(p_handle, true);
      this.fetchProductExistLocal();
      wishlistContent();
  };
  deleteProduct = async (id) => {
      if (!id) return;
  
      const response = await removeProductApi(id);
      if (response?.status === 200) {
          this.getCategoryAllData();
          wishlistContent();
      }
  };

  deleteProductLocal = async (id) => {
      if (!id) return;
  
      let productsData = techno_getCookie("wishlist");
      let categoryData = techno_getCookie("wishlist_category");
  
      try {
          productsData = productsData ? JSON.parse(productsData) : [];
          categoryData = categoryData ? JSON.parse(categoryData) : [];
  
          // Filter out the deleted product
          productsData = productsData.filter(item => item.p_id !== id);
  
          // Update cookies
          techno_setCookie("wishlist", "", 0); // Clear old cookie
          techno_setCookie("wishlist", JSON.stringify(productsData), 100);
  
          // Remove product from guest category
          await removeProductApi(id, true, categoryData[0]?.category_id);
  
          // Refresh UI
          this.fetchProductExistLocal();
          wishlistContent();
      } catch (error) {
          console.error("Error deleting product locally:", error);
      }
  };

  setButtons = () => {
      if (window.isWishlistSharedPage) return false;
  
      const allPlaceParent = document.querySelectorAll(".wishlist-pdp-btn-main");
      const { button_style, button_setting, vote_btn, save_for_later } = this.wishlistMeta;
      
      const buttonStyleClass = getMainButtonClass(button_style.btnStyle);
      const styles = {
          btnColor: button_style.btnColor,
          btnBg: button_style.btnBgColor,
          btnAfterColor: button_style.btnColorAfterWishlist,
          btnAfterBg: button_style.btnBgColorAfterWishlist
      };
  
      allPlaceParent.forEach(ele => {
          ele.classList.add(buttonStyleClass);
          ele.style = `--tt-main-btn-color:${styles.btnColor}; --tt-main-btn-bg:${styles.btnBg}; --tt-main-af-btn-color:${styles.btnAfterColor}; --tt-main-af-btn-bg:${styles.btnAfterBg};`;
  
          let voteBtn = "";
          if (this.customerExist && vote_btn.enable) {
              voteBtn = `
                  <button type="button" class="tt-vote-btn-wrap">
                      <span class="tt-vote-btn-span tt-vote-init-label">
                          <span class="tt-vote-icon">${wishlistLikeEmptyIcon}</span>
                          <span class="tt-vote-count">0</span>
                      </span>
                      <span class="tt-vote-btn-span tt-vote-after-label">
                          <span class="tt-vote-icon">${wishlistLikeFillIcon}</span>
                          <span class="tt-vote-count">0</span>
                      </span>
                  </button>
              `;
          }
  
          ele.innerHTML = `
              <div class="wishlist-pdp-btn-main-wrap">
                  <button type="button" class="wishlist-pdp-btn-wrap ${voteBtn ? "" : "full-width"}">
                      <span class="wishlist-btn-content-span wishlist-init-label">
                          <span class="wishlist-icon">${wishlistEmptyIcon}</span>
                          <span class="tt-btn-text">${button_style.btnText}</span>
                      </span>
                      <span class="wishlist-btn-content-span wishlist-after-label">
                          <span class="wishlist-icon">${wishlistFillIcon}</span>
                          <span class="tt-btn-text">${button_style.btnTextAfterWishlist}</span>
                      </span>
                  </button>
                  ${voteBtn}
              </div>
          `;
      });
  
      // Floating Button
      if (button_setting.launch_btn_type === "floating_btn") {
          const floatingButton = document.createElement("DIV");
          floatingButton.className = `wishlist-floating-btn-main ${button_setting.launch_btn_placement} ${button_setting.launch_btn_style} ${button_setting.launch_btn_radius}`;
          floatingButton.style = `--floating-btn-color:${button_setting.launch_btn_text_color}; --floating-btn-bg:${button_setting.launch_btn_bg_color};`;
  
          floatingButton.innerHTML = `
              <button type="button" class="wishlist-floting-btn-wrap">
                  <span class="wishlist-icon">${wishlistEmptyIcon}</span>
                  <span class="wishlist-btn-text">${button_setting.launch_btn_text}</span>
              </button>
          `;
          document.body.append(floatingButton);
      }
  
      // Setup vote button if enabled
      if (this.customerExist && vote_btn.enable) this.setupVoteBtn();
  
      // PLP Buttons
      const plpBtnWrap = document.querySelectorAll(".tt-wishlist-plp-btn-main");
      const collectionStyle = window.wishlistMetafields.collection;
      
      plpBtnWrap.forEach(ele => {
          if (save_for_later === 0 && ele.classList.contains("tt-cart-btn")) return;
  
          ele.style = `--wishlist-plp-btn-color:${collectionStyle.icon_before_wishlist_color}; --wishlist-plp-btn-bg:${collectionStyle.icon_after_wishlist_color};`;
          ele.classList.add("tt-position", collectionStyle.icon_position);
  
          ele.innerHTML = `
              <button class="wishlist-plp-btn-wrap" type="button">
                  <span class="wishlist-btn-content-span wishlist-init-label">${wishlistEmptyIcon}</span>
                  <span class="wishlist-btn-content-span wishlist-after-label">${wishlistFillIcon}</span>
              </button>
          `;
  
          if (save_for_later === 1 && ele.classList.contains("tt-cart-btn")) {
              ele.innerHTML = `
                  <button class="wishlist-plp-btn-wrap" type="button">
                      <span class="wishlist-btn-content-span wishlist-init-label">Save for later</span>
                      <span class="wishlist-btn-content-span wishlist-after-label">Save for later</span>
                  </button>
              `;
          }
      });
  };

    createCategory = async () => {
        const getCategories = await getCategoriesApi();
        if (!getCategories?.data?.length) return;
    
        let currentCategoryHtml = getCategories.data.map(ele => `
            <div class="tt-form-group">
                <span class="wishlist-p-tag">${ele.category_name}</span>
                <button type="button" class="tt-btn tt-add-wishlist" cat-id="${ele.category_id}">Add</button>
            </div>
        `).join("");
    
        const categoryHtml = `
            <div class="wishlist-create-category-popup">
                <div class="tt-popup-overlay"></div>
                <div class="tt-category-popup">
                    <div class="tt-category-close">${wishlistPopupCloseIcon}</div>
                    <div class="tt-popup-content">
                        <div class="tt-wishlist-form">
                            <div class="tt-form-title">
                                <p class="wishlist-p-tag">Add this item to a category</p>
                            </div>
                            <div class="tt-cat-wrap">${currentCategoryHtml}</div>
                            <div class="tt-form-new-group">
                                <input type="text" name="wishlistname" placeholder="Create New Category">
                                <button type="button" class="tt-btn tt-add-wishlist">Create Category</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        `;
    
        const existingPopup = document.querySelector(".wishlist-create-category-popup-main");
        if (existingPopup) {
            existingPopup.innerHTML = categoryHtml;
        } else {
            const divEle = document.createElement("DIV");
            divEle.className = "wishlist-create-category-popup-main";
            divEle.innerHTML = categoryHtml;
            document.body.append(divEle);
        }
    
        this.clickEvents();
        this.getCategoryAllData(getCategories);
    };

   setupVoteBtn = async () => {
      const wishlistMainBtn = document.querySelectorAll(".wishlist-pdp-btn-main");
      if (!wishlistMainBtn.length) return;
  
      const pId = wishlistMainBtn[0]?.getAttribute("data-pid");
      if (!pId) return;
  
      const voteCustomerData = await getCustomerVoteDataApi(pId);
      if (voteCustomerData?.status !== 200) return;
  
      const { btn_color, btn_bg, after_btn_color, after_btn_bg } = this.wishlistMeta.vote_btn;
  
      wishlistMainBtn.forEach(ele => {
          const voteBtn = ele.querySelector(".tt-vote-btn-wrap");
          if (!voteBtn) return;
  
          voteBtn.style = `--tt-vote-btn-color:${btn_color}; --tt-vote-btn-bg:${btn_bg}; --tt-vote-af-btn-color:${after_btn_color}; --tt-vote-af-btn-bg:${after_btn_bg};`;
  
          voteBtn.querySelectorAll(".tt-vote-count").forEach(innerEle => {
              innerEle.innerHTML = voteCustomerData.data;
          });
  
          voteBtn.classList.toggle("active", voteCustomerData.customerVote === 1);
      });
  };

   settingsBasedContent = () => {
        const { language2, share_wishlist, share_wishlist_data } = window.wishlistMetafields;
        let isEle = document.querySelector(window.wishlistPageSelector) || document.querySelector(window.wishlistSharedPageSelector);
    
        if (isEle) {
            if (document.querySelector(".tt-details-title p") && language2.page_title) {
                document.querySelector(".tt-details-title p").innerHTML = language2.page_title;
            }
    
            pageCountApi();
            const mainEle = document.querySelector(".tt-wishlist-details-main");
            if (mainEle) isEle.append(mainEle);
    
            if (isEle === document.querySelector(window.wishlistSharedPageSelector)) {
                window.isWishlistSharedPage = true;
                return false;
            }
        }
    
        if (share_wishlist === 1 && window.customerExist) {
            const shareButton = document.querySelector(".tt-wishlist-share-btn");
            const sharePopup = document.querySelector(".tt-share-wishlist-popup");
    
            if (shareButton && sharePopup) {
                shareButton.classList.remove("tt-hide");
                document.body.append(sharePopup);
    
                const hideShareOptions = {
                    ".tt-fb-share": share_wishlist_data.facebook,
                    ".tt-twitter-share": share_wishlist_data.twitter,
                    ".tt-wp-share": share_wishlist_data.whatsapp,
                    ".tt-email-share": share_wishlist_data.email,
                    ".tt-share-copy": share_wishlist_data.copy_link,
                };
    
                Object.entries(hideShareOptions).forEach(([selector, enabled]) => {
                    if (enabled === 0) sharePopup.querySelector(selector)?.classList.add("tt-hide");
                });
            }
        }
    };

    trendingWishlistSetup = async () => {
        const selectors = document.querySelectorAll(".super-wishlist-trending-widget");
        if (!selectors.length || this.wishlistMeta.show_trending_wishlist === 0) return false;
    
        const trendingData = await trendingApi();
        if (trendingData?.status !== 200 || !trendingData?.data?.length) return;
    
        const {
            trending_layout,
            trending_title,
            trending_desktop_per_row,
            trending_mobile_per_row,
            trending_slider_arrows,
            trending_slider_auto_rotate
        } = this.wishlistMeta.trending;
    
        const productsHtml = trendingData.data.map(ele => `
            <div class="tt-product-list swiper-slide" data-handle="${ele.handle}"></div>
        `).join("");
    
        const trendingHtml = `
            <div class="tt-container">
                <div class="tt-wishlist-trending-wrap">
                    <div class="tt-trending-title-wrap">
                        <p>${trending_title}</p>
                    </div>
                    <div class="tt-wishlist-trending-inner-wrap swiper">
                        <div class="swiper-wrapper">${productsHtml}</div>
                        <div class="swiper-button swiper-button-next"></div>
                        <div class="swiper-button swiper-button-prev"></div>
                    </div>
                </div>
            </div>
        `;
    
        selectors.forEach(ele => {
            ele.classList.add(trending_layout);
            ele.setAttribute("data-desktop-row", trending_desktop_per_row);
            ele.setAttribute("data-mobile-row", trending_mobile_per_row);
            ele.setAttribute("data-arrow", trending_slider_arrows);
            ele.setAttribute("data-auto-rotate", trending_slider_auto_rotate);
            ele.style = `--tt-wishlist-font-multipler:1;${trending_layout === "slider" ? "opacity:0;" : ""}`;
            ele.innerHTML = trendingHtml;
        });
    
        updateProductContent(trending_layout === "slider", true);
    };

     setGuest = async () => {
        const { guest_wishlist } = window.wishlistMetafields;
        
        // Only proceed if guest wishlist is enabled and user is not logged in
        if (guest_wishlist !== 1 || window.customerExist || window.location.pathname.includes("wishlist-share")) {
            return;
        }
    
        let guestCustomerId = techno_getCookie("techno_guest_user_id");
    
        try {
            let url, isNewGuest = false;
    
            if (guestCustomerId) {
                url = `${window.wishlistUrl}create-guest-user?customer_id=${guestCustomerId}`;
            } else {
                url = `${window.wishlistUrl}create-guest-user`;
                isNewGuest = true;
            }
    
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                }
            });
    
            const guestData = await response.json();
    
            if (guestData?.status === 200 && guestData?.customer_id) {
                // Save the guest ID only if it's newly created
                if (isNewGuest) {
                    techno_setCookie("techno_guest_user_id", guestData.customer_id, 100);
                }
    
                // Update global variables
                window.customerId = guestData.customer_id;
                window.customerExist = true;
                
                // Update share URLs
                this.updateShareUrls();
            } else {
                console.error("Guest user creation failed:", guestData);
            }
    
        } catch (error) {
            console.error("Error creating guest user:", error);
        }
    };

   updateShareUrls = () => {
      if (!window.customerId) {
          console.error("window.customerId is not defined.");
          return;
      }
  
      const updateUrlParam = (element, attribute) => {
          try {
              const url = new URL(element[attribute]);
              if (!url.searchParams.get('q')) {
                  url.searchParams.set('q', window.customerId);
                  element[attribute] = url.toString();
              }
          } catch (error) {
              console.error(`Invalid URL in ${attribute}:`, element[attribute]);
          }
      };
  
      // Update all share links
      document.querySelectorAll('.tt-share-wishlist a').forEach(link => updateUrlParam(link, 'href'));
  
      // Update the "Share With URL" input field
      const shareInput = document.getElementById('ttCopyShareUrlText');
      if (shareInput) updateUrlParam(shareInput, 'value');
  };

    init = () => {
        const { trending, guest_wishlist } = window.wishlistMetafields || {};
        
        // Load Swiper styles and script if needed
        if (trending?.trending_layout === "slider") {
            // ["https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css", 
            //  "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"].forEach((src, index) => {
            //     const element = document.createElement(index === 0 ? "link" : "script");
            //     if (index === 0) {
            //         element.rel = "stylesheet";
            //         element.href = src;
            //         document.head.appendChild(element);
            //     } else {
            //         element.src = src;
            //         document.body.appendChild(element);
            //     }
            // });
        }
    
        this.setButtons();
    
        // Assign click event handler globally
        window.ttWishlistClickEvents = () => this.clickEvents();
    
        // Handle customer state and guest wishlist logic
        if (this.customerExist) {
            this.createCategory();
        } else if (guest_wishlist === 1) {
            this.fetchProductExistLocal();
            this.clickEvents();
        } else {
            this.clickEvents();
        }
    
        this.settingsBasedContent();
        wishlistContent();
    };

  reButtonsInit = () => {
      this.setButtons();
  
      if (this.customerExist) {
          this.createCategory();
      } else if (window.wishlistMetafields?.guest_wishlist === 1) {
          this.fetchProductExistLocal();
      }
  
      this.settingsBasedContent();
      wishlistContent();
  };

}
const wishlistData = new WishlistPDP();

window.wishlistInit = () => wishlistData.init();
window.wishlistButtonsInit = () => wishlistData.reButtonsInit();
